import { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import AdminService from "../../../services/admin";
import { NotificationManager } from "react-notifications";

const TABLE_COLUMNS = [
  { id: "adId", label: "Ad Id" },
  { id: "postId", label: "Post Id" },
  { id: "fName", label: "First Name" },
  { id: "lName", label: "Last Name" },
  { id: "phone", label: "Phone Number" },
  { id: "email", label: "Email" },
  { id: "status", label: "Status" },
];

export const useIncompletedAdsView = () => {
  const history = useHistory();

  const [searchQuery, setSearchQuery] = useState("");
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const mapPostToResult = (post) => ({
    adId: post?.memberId ?? "N/A",
    postId: post?.id ?? "N/A",
    fName: post?.personalInfo?.fname ?? "N/A",
    lName: post?.personalInfo?.lname ?? "N/A",
    phone: post?.phone ?? "",
    email: post?.email ?? "N/A",
    status: post?.status ?? "N/A",
  });

  const filteredResults = useMemo(() => {
    const query = searchQuery.trim().toLowerCase();
    if (!query) {
      return results;
    }
    return results.filter((result) =>
      Object.values(result).some((value) =>
        String(value).toLowerCase().includes(query),
      ),
    );
  }, [results, searchQuery]);

  const handleClickTableRow = (row) => {
    history.push({
      pathname: "/post",
      search: `?id=${row?.postId ?? ""}`,
    });
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event?.target?.value ?? "");
  };

  useEffect(() => {
    AdminService.getPostsByStatus({ status: "INCOMPLETE" })
      .then(({ body }) => {
        setResults(body.map(mapPostToResult));
      })
      .catch((error) => {
        console.error("Failed to fetch posts:", error);
        NotificationManager.error("Failed to fetch results");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return {
    TABLE_COLUMNS,
    results: filteredResults,
    searchQuery,
    total: results.length,
    isLoading,
    handleSearchChange,
    handleClickTableRow,
  };
};
